import { Chip } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

export interface TableCellIngestPriorityChipProps {
  data: any;
}

const TableCellIngestPriorityChip: FC<TableCellIngestPriorityChipProps> = (props) => {
  const { t } = useTranslation();
  const priority = props.data.value;
  let color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
  let text;
  if (priority <= 50) {
    color = "default";
    text = t("common:normal");
  } else if (priority > 50 && priority < 75) {
    color = "warning";
    text = t("common:high");
  } else {
    color = "error";
    text = t("common:critical");
  }

  return <Chip label={`${text}`} key={text} size="small" color={color} sx={{ mr: 0.5 }} />;
};

export default TableCellIngestPriorityChip;
